import IntersectionObserverProvider from "@/assets/plugins/mps-common/intersectionObserverProvider/intersection-observer-provider";

export default {
    install(Vue) {
        Vue.prototype.$io = IntersectionObserverProvider
    }

}